<template>
  <div class="main">
    <HomeBanners />

    <div id="blue-sky">
      <ContentWrapper><FeaturedNews /></ContentWrapper>
      <ContentWrapper><ExperienceSection /></ContentWrapper>
    </div>
    <div class="background" />
    <div id="maple-connection">
      <MapleConnection />
      <!-- <img class="building-on right abs" src="@/assets/imgs/home/building-on-right.webp" />
      <img class="building-on left abs" src="@/assets/imgs/home/building-on-left.webp" /> -->
    </div>
    <div class="maple-heroes-advanced-skills">
      <MapleHeroes />
      <AdvancedSkills />
      <div class="asmaple-heroes-advanced-skills__bg2"></div>
      <div class="asmaple-heroes-advanced-skills__bg1"></div>
    </div>
    <HomeRanking />
    <VideoBanner />
    <MediaPlatformLinks />
  </div>
</template>
<script setup lang="ts">
  import { lazyLoadComponent } from '@/helpers/lazyLoadComponent'
  import { gsap } from 'gsap'
  import { ScrollTrigger } from 'gsap/ScrollTrigger'
  import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
  import { onMounted } from 'vue'
  const ExperienceSection = lazyLoadComponent({
    comp: () => import('@/components/Home/ExperienceSection.vue'),
  })
  const MapleConnection = lazyLoadComponent({
    comp: () => import('@/components/Home/MapleConnection.vue'),
  })
  const MapleHeroes = lazyLoadComponent({
    comp: () => import('@/components/Home/MapleHeroes.vue'),
  })
  const AdvancedSkills = lazyLoadComponent({
    comp: () => import('@/components/Home/AdvancedSkills.vue'),
  })
  const HomeRanking = lazyLoadComponent({
    comp: () => import('@/components/Home/HomeRanking.vue'),
  })
  const VideoBanner = lazyLoadComponent({
    comp: () => import('@/components/Common/VideoBanner.vue'),
  })
  const MediaPlatformLinks = lazyLoadComponent({
    comp: () => import('@/components/Home/MediaPlatformLinks.vue'),
  })
  onMounted(() => {
    gsap.registerPlugin(ScrollTrigger, MotionPathPlugin)
  })
</script>
<style lang="scss" scoped>
  .main {
    max-width: 100%;
    min-height: 1600px;
    overflow: hidden;
  }
  #blue-sky {
    position: relative;
    padding: 30px 0 0;
    width: 100%;
    // height: min(calc(580px + 50vw), 1450px);
    background: url('@/assets/imgs/home/bg_sky.webp') repeat-x;
    background-size: 2px 100%;
    overflow: hidden;
    margin-bottom: -1px;
  }

  .maple-heroes-advanced-skills {
    background: url('@/assets/imgs/home/mapleheroes-advancedskills/bg_advanced-skills.png') repeat-x center bottom,
      url('@/assets/imgs/home/mapleheroes-advancedskills/bg_maple-heroes.jpg') repeat-x center top, #143055;
  }
  .background {
    position: absolute;
    width: 100%;
    height: 190px;
    z-index: 1;
    margin-top: -145px;
    background: url('@/assets/imgs/home/experience/bg_tree.webp') repeat-x bottom;
  }

  @media (max-width: 1350px) {
    .maple-heroes-advanced-skills {
      background: url('@/assets/imgs/home/mapleheroes-advancedskills/bg_advanced-skills.png') repeat-x center bottom/
          50% auto,
        url('@/assets/imgs/home/mapleheroes-advancedskills/bg_maple-heroes.jpg') repeat-x center top;
    }
  }
  @media #{$tablet} {
    .maple-heroes-advanced-skills {
      background: #242d50;
    }
  }
  @media #{$mobile} {
    .maple-heroes-advanced-skills {
      background: none;
    }
  }
</style>
